module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "financeSetA"
  }, [_c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 库存列表")]), _vm._v(" "), _c('div', {
    staticClass: "monewt",
    staticStyle: {
      "min-width": "1000px"
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "货物名称 :"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "224px"
    },
    attrs: {
      "placeholder": "输入货物名称查询"
    },
    model: {
      value: (_vm.orderNOA),
      callback: function($$v) {
        _vm.orderNOA = $$v
      },
      expression: "orderNOA"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-left": "-70px"
    },
    attrs: {
      "label": "用户名:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "输入用户名/VIP号查询"
    },
    on: {
      "input": function($event) {
        return _vm.realDateA(_vm.orderNOC)
      }
    },
    model: {
      value: (_vm.orderNOC),
      callback: function($$v) {
        _vm.orderNOC = $$v
      },
      expression: "orderNOC"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-left": "-90px"
    },
    attrs: {
      "label": "运单号:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "输入运单号查询"
    },
    on: {
      "input": function($event) {
        return _vm.realDateB(_vm.orderNOD)
      }
    },
    model: {
      value: (_vm.orderNOD),
      callback: function($$v) {
        _vm.orderNOD = $$v
      },
      expression: "orderNOD"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单编号："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "224px"
    },
    attrs: {
      "placeholder": "输入订单编号查询"
    },
    model: {
      value: (_vm.orderNOB),
      callback: function($$v) {
        _vm.orderNOB = $$v
      },
      expression: "orderNOB"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getStoreList('1')
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportToExcel()
      }
    }
  }, [_vm._v("导出Excel")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orderMoney,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "adminId",
      "label": "序号",
      "align": "center",
      "min-width": "70px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          domProps: {
            "textContent": _vm._s(_vm.getIndex(scope.$index))
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "min-width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          attrs: {
            "align": "center"
          }
        }, [_vm._v(_vm._s(scope.row.productName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "prop": "productNum",
      "min-width": "100px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "库位",
      "prop": "shelves",
      "min-width": "100px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "入库时间",
      "prop": "storeTime",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "关联运单号",
      "prop": "orderNo",
      "min-width": "200px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(scope.row.expressNo))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "关联订单编号",
      "prop": "orderNo",
      "min-width": "200px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "ss",
          on: {
            "click": function($event) {
              return _vm.getorderNo(scope.row.orderNo)
            }
          }
        }, [_vm._v("\n            " + _vm._s(scope.row.orderNo) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "userName",
      "min-width": "100px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户VIP号",
      "prop": "vipCode",
      "min-width": "100px",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.showG,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showG", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("您确认改变该合箱状态嘛？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.affirmC()
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialog.showG = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "600px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "wrl-marign"
  }, [_c('div', {
    staticClass: "wrl-hedaNa"
  }), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("订单号：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.orderNo))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("下单时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.addDate))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户名称：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.userName))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户电话：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.userTel))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户vip：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.vipCode))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("快递公司：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.expressCompany))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("快递单号：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.expressNo))]), _vm._v(" "), _c('div', {
    staticClass: "bt",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "text",
      "data-clipboard-text": _vm.orderInfo.expressNo
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("复制")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("订单状态：")]), _vm._v(" "), _c('div', [(_vm.orderInfo.status == 1) ? _c('span', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_vm._v("\n            待入库\n          ")]) : (_vm.orderInfo.status == 2) ? _c('span', {
    staticStyle: {
      "color": "#f59a23"
    }
  }, [_vm._v("\n            已入库\n          ")]) : (_vm.orderInfo.status == 3) ? _c('span', {
    staticStyle: {
      "color": "#70b603"
    }
  }, [_vm._v("\n            已出库\n          ")]) : (_vm.orderInfo.status == 4) ? _c('span', {
    staticStyle: {
      "color": "#70b603"
    }
  }, [_vm._v("\n            已结单\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("合箱状态：")]), _vm._v(" "), _c('div', {
    staticClass: "bt"
  }, [(_vm.orderInfo.isBox == 1) ? _c('div', [_c('span', [_vm._v("合箱")])]) : _c('div', [_c('span', {
    staticClass: "red",
    attrs: {
      "type": "text"
    }
  }, [_vm._v("不合箱")])])]), _vm._v(" "), _c('div', {
    staticClass: "bt",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.getorderNoB(_vm.orderInfo.orderNo, _vm.orderInfo.isBox)
      }
    }
  }, [_vm._v("修改")])], 1)]), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("入库时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.storeTime))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 3) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("出库时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.deliveryTime))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("实际尺寸：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.productSize) + " CBM")])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("实际重量：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.productWeight) + " KG")])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', [_vm._v("最后费用：")]), _vm._v(" "), _c('div', [_vm._v("CAD " + _vm._s(_vm._f("priceFilt")(_vm.orderInfo.total)))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.remark) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("订单备注：")]), _vm._v(" "), (_vm.orderInfo.remark) ? _c('div', [_vm._v(_vm._s(_vm.orderInfo.remark))]) : _c('div', [_vm._v("无")])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("用户备注：")]), _vm._v(" "), (_vm.orderInfo.userRemark) ? _c('div', [_vm._v(_vm._s(_vm.orderInfo.userRemark))]) : _c('div', [_vm._v("无")])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status == 1) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("预估费用：")]), _vm._v(" "), _c('div', [_vm._v("CAD " + _vm._s(_vm._f("priceFilt")(_vm.orderInfo.total)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrl-productList"
  }, [_c('div', [_vm._v("商品清单")]), _vm._v(" "), _c('div', {
    staticClass: "wrl-border"
  }), _vm._v(" "), _vm._l((_vm.orderInfo.productList), function(val, i) {
    return _c('div', {
      key: i,
      staticClass: "wrl-list"
    }, [_c('div', {
      staticClass: "wrl-flex2"
    }, [_c('div', {
      staticClass: "wrl-felx3"
    }, [_vm._v("\n              " + _vm._s(i + 1) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx4",
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_c('div', {
      staticClass: "ellipsisB",
      staticStyle: {
        "-webkit-box-orient": "vertical"
      }
    }, [_vm._v("\n                " + _vm._s(val.productName) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx5",
      staticStyle: {
        "display": "flex",
        "margin-top": "5px"
      }
    }, [_c('div', {
      staticStyle: {
        "flex": "1"
      }
    }, [_vm._v(_vm._s(val.productNum) + "件")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex": "1",
        "min-width": "50px"
      }
    }, [_vm._v(_vm._s(val.weight) + "kg")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex": "2",
        "min-width": "100px"
      }
    }, [_vm._v("\n                  " + _vm._s(val.productLong) + "x" + _vm._s(val.width) + "x" + _vm._s(val.height) + "cm\n                ")]), _vm._v(" "), (val.productRemark) ? _c('div', {
      staticStyle: {
        "flex": "2",
        "color": "#ec808d"
      }
    }, [_vm._v("\n                  " + _vm._s(val.productRemark) + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx6 ",
      staticStyle: {
        "margin-left": "0px",
        "min-width": "80px"
      }
    }, [(val.shelves) ? _c('div', {
      staticStyle: {
        "color": "#ec808d"
      }
    }, [_vm._v("\n                货架:  " + _vm._s(val.shelves) + "\n                ")]) : _vm._e()]), _vm._v(" "), (val.productImg) ? _c('div', {
      staticClass: "wrl-felx6 cursor",
      on: {
        "click": function($event) {
          return _vm.opBa(val.productImg)
        }
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": val.productImg,
        "fit": "contain"
      }
    })], 1) : _c('div', {
      staticClass: "wrl-felx6"
    }, [_c('div', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      }
    })]), _vm._v(" "), (val.productImgB) ? _c('div', {
      staticClass: "wrl-felx6 cursor",
      on: {
        "click": function($event) {
          return _vm.opBa(val.productImgB)
        }
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": val.productImgB,
        "fit": "contain"
      }
    })], 1) : _c('div', {
      staticClass: "wrl-felx6"
    }, [_c('div', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      }
    })])])])
  })], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fe8a507"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/repertory/repertoryList.vue
// module id = 1256
// module chunks = 2